module.exports = __webpack_public_path__ + "img/patternless.63696c49.png";